import { GlueServerClient } from '@/src/lib/http/client/client.glue.server';
import { CollectionApiFormat } from '@/src/lib/http/jsonapi/deserializer';
import { Customer } from '@/src/lib/customer/types';
import { GlueClient } from '@/src/lib/http/client/client.glue';
import { RevalidateTags } from '@/src/lib/http/types';

type CustomerInclude = 'companies';
export const REVALIDATE_TIME = 1;

export const API_PATH = '/customers';

export const getCustomer = async (
  include: Array<CustomerInclude> = [],
  client: GlueClient | GlueServerClient,
  guestId?: string,
) => {
  const headers = guestId
    ? new Headers({
        'x-anonymous-customer-unique-id': guestId,
      })
    : undefined;

  const res = await client.get(`${API_PATH}${include.length ? `?include=${include.join(',')}` : ''}`, {
    withAuth: true,
    next: {
      tags: [RevalidateTags.CUSTOMER],
      revalidate: 3600,
    },
    headers,
  });

  return client.handleResponse<CollectionApiFormat<Customer>>(res);
};
